import { render } from "./ContratosVigentes.vue?vue&type=template&id=70b3bd32&scoped=true"
import script from "./ContratosVigentes.vue?vue&type=script&lang=js"
export * from "./ContratosVigentes.vue?vue&type=script&lang=js"

import "./ContratosVigentes.vue?vue&type=style&index=0&id=70b3bd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b3bd32"]])

export default __exports__